const BASE_URL = '/api/collections/news/entries';
const FIELDS = 'url,title,perex,image,date,conference_categories';

export default () => ({
  page: 2,
  posts: [],
  postsLoading: false,
  filter: 'all',
  filterColor: '',
  lastPage: 10,

  init() {
    this.$locale(document.documentElement.lang);
  },

  getPosts() {
    if (this.page == 1) {
      this.posts = [];
    }
    this.postsLoading = true;
    fetch(
      `${BASE_URL}?filter[site]=${this.$locale()}&limit=12&page=${
        this.page
      }&fields=${FIELDS}&sort=-date${
        this.filter == 'all'
          ? ''
          : '&filter[taxonomy:conference_categories:in]=' + this.filter
      }`
    )
      .then((response) => response.json())
      .then((response) => {
        this.lastPage = response.meta.last_page;
        response.data.forEach((item) => {
          this.posts.push(item);
        });
        this.postsLoading = false;
      });
    this.page++;
  },

  filterAll() {
    this.filter = 'all';
    this.page = 2;
    this.posts = [];
    this.filterColor = '';
  },

  get buttonText() {
    return this.postsLoading ? this.$t('loading') : this.$t('showMore');
  },
});
